import { createUseStyles } from "react-jss";
import { PickersDay } from "@mui/x-date-pickers";
import React__default from "react";
const useStyles = createUseStyles(
  {
    selected: {
      backgroundColor: "#FAD14C",
      "&:hover": {
        backgroundColor: "#eac449"
      }
    },
    between: {
      backgroundColor: "#FAF9D8",
      "&:hover": {
        backgroundColor: "#dad9be"
      }
    }
  },
  { name: "DatePickerDay" }
);
const Day = (props) => {
  const { day, startDate, endDate, ...rest } = props;
  const classes = useStyles();
  const isSelected = day && (startDate && (day == null ? void 0 : day.isSame(startDate, "day")) || endDate && (day == null ? void 0 : day.isSame(endDate, "day")));
  const isBetween = day == null ? void 0 : day.isBetween(startDate, endDate, "day");
  return /* @__PURE__ */ React__default.createElement(
    PickersDay,
    {
      day,
      className: `${isSelected ? classes.selected : ""}  ${isBetween ? classes.between : ""}`,
      ...rest
    }
  );
};
export {
  Day
};
//# sourceMappingURL=Day.js.map
